import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment } from 'react';
import { createStorePersist, RequestStatus, useHeight, useWidth } from "common-frontend-components";
import { getStorageCall } from '@yehonadav/safestorage';
import { callGetSitePhotosByGroupAsync } from "../../apis/sitePhotos";
import { useEffect } from "react";
import { Image } from "../custom/images/Image";
import { useHistory } from "react-router";
import { Grid, Typography } from "@mui/material";
import { enablePersistentCache } from "../../utils/enablePersistentCache";
import { sortAppConfigItems } from "../../utils/sortAppConfigItems";
import { LoadingPleaseWait } from "../loaders/Loader";
const groupName = 'about/*';
const persistOptions = {
    name: `site-config/${groupName}`,
    whitelist: ["data", "cache", "groupConfig"],
    getStorage: getStorageCall,
};
const getDefaultValues = () => ({
    data: [],
    status: RequestStatus.pending,
});
const { get, set, useStore, fetchStore } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues,
});
// ensure cache is a date
enablePersistentCache(get);
const useStatus = () => useStore(fetchStore.status);
export const aboutStore = {
    useLoad: () => {
        const status = useStatus();
        useEffect(() => {
            if (get().status !== RequestStatus.pending)
                return;
            const { cache, groupConfig } = get();
            if (cache !== undefined && cache.getTime() + (groupConfig?.params?.cacheSeconds || 0) * 1000 > Date.now())
                return set({ status: RequestStatus.loaded });
            set({ status: RequestStatus.loading });
            callGetSitePhotosByGroupAsync(groupName)
                .then(data => {
                const config = data.find(i => i.params?.component === "group-config");
                set({
                    data: sortAppConfigItems(data
                        .filter(i => i.params?.component !== 'group-config'), config), groupConfig: config,
                    cache: typeof config?.params?.cacheSeconds === 'number' ? new Date() : undefined,
                    status: RequestStatus.loaded,
                });
            })
                .catch(() => set({ status: RequestStatus.failed }));
        }, [status]);
    },
    useData: () => useStore(s => s.data),
    useStatus,
    useCache: () => useStore(s => s.cache),
    getData: () => get().data,
    getStatus: () => get().status,
    getCache: () => get().cache,
};
export const SectionItemText = ({ conf = {} }) => {
    return (_jsx(Typography, { variant: "body1", gutterBottom: true, ...(conf.props || {}), children: conf.text.map((line, index) => _jsxs(Fragment, { children: [line, conf.text.length - 1 > index ? _jsx("br", {}, void 0) : ''] }, index)) }, void 0));
};
export const SectionItemImage = ({ item, conf = {} }) => {
    const width = useWidth();
    const height = useHeight();
    const history = useHistory();
    return (_jsx(Image, { maxWidth: width, maxHeight: height, src: item.url, alt: item.path, onClick: () => conf.onClickRoute && history.push(conf.onClickRoute), ...(conf.props || {}) }, void 0));
};
export const SectionItem = ({ item, conf = {} }) => {
    return (_jsx(Grid, { item: true, ...(conf.props || {}), children: Array.isArray(conf.children)
            ? conf.children.map((i, index) => i.component === 'section-item-img' ? _jsx(SectionItemImage, { item: item, conf: i }, index) :
                i.component === 'section-item-text' ? _jsx(SectionItemText, { item: item, conf: i }, index) :
                    null)
            : null }, void 0));
};
export const SectionContainer = ({ item, conf = {} }) => {
    return (_jsx(Grid, { container: true, component: 'section', ...(conf.props || {}), children: Array.isArray(conf.children)
            ? conf.children.map((i, index) => i.component === 'section-item'
                ? _jsx(SectionItem, { item: item, conf: i }, index)
                : null)
            : null }, void 0));
};
export const AboutSections = () => {
    aboutStore.useLoad();
    const data = aboutStore.useData();
    const status = aboutStore.useStatus();
    if (status === RequestStatus.loading && data.length === 0)
        return _jsx(LoadingPleaseWait, {}, void 0);
    return (_jsx(_Fragment, { children: data
            .filter(i => i.params?.component === 'section-container')
            .map(i => _jsx(SectionContainer, { item: i, conf: i.params || {} }, i.id)) }, void 0));
};
//# sourceMappingURL=AboutSections.js.map